"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tableau Services APIs
 * Open API specification for Tableau Services APIs
 *
 * The version of the OpenAPI document: latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
/**
* @export
* @enum {string}
*/
var TableauNlpRefinementuiSearchFieldsAndValuesRequestPhraseShelfTypeEnum;
(function (TableauNlpRefinementuiSearchFieldsAndValuesRequestPhraseShelfTypeEnum) {
    TableauNlpRefinementuiSearchFieldsAndValuesRequestPhraseShelfTypeEnum["Unspecified"] = "PHRASESHELFTYPE_UNSPECIFIED";
    TableauNlpRefinementuiSearchFieldsAndValuesRequestPhraseShelfTypeEnum["Primary"] = "PHRASESHELFTYPE_PRIMARY";
    TableauNlpRefinementuiSearchFieldsAndValuesRequestPhraseShelfTypeEnum["Secondary"] = "PHRASESHELFTYPE_SECONDARY";
})(TableauNlpRefinementuiSearchFieldsAndValuesRequestPhraseShelfTypeEnum = exports.TableauNlpRefinementuiSearchFieldsAndValuesRequestPhraseShelfTypeEnum || (exports.TableauNlpRefinementuiSearchFieldsAndValuesRequestPhraseShelfTypeEnum = {}));
function TableauNlpRefinementuiSearchFieldsAndValuesRequestFromJSON(json) {
    return TableauNlpRefinementuiSearchFieldsAndValuesRequestFromJSONTyped(json, false);
}
exports.TableauNlpRefinementuiSearchFieldsAndValuesRequestFromJSON = TableauNlpRefinementuiSearchFieldsAndValuesRequestFromJSON;
function TableauNlpRefinementuiSearchFieldsAndValuesRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'query': !runtime_1.exists(json, 'query') ? undefined : json['query'],
        'lensLuid': !runtime_1.exists(json, 'lens_luid') ? undefined : json['lens_luid'],
        'datasourceId': !runtime_1.exists(json, 'datasource_id') ? undefined : json['datasource_id'],
        'lodExpInPlayJson': !runtime_1.exists(json, 'lod_exp_in_play_json') ? undefined : json['lod_exp_in_play_json'],
        'selectedNodeIndex': !runtime_1.exists(json, 'selected_node_index') ? undefined : json['selected_node_index'],
        'phraseShelfType': !runtime_1.exists(json, 'phrase_shelf_type') ? undefined : json['phrase_shelf_type'],
    };
}
exports.TableauNlpRefinementuiSearchFieldsAndValuesRequestFromJSONTyped = TableauNlpRefinementuiSearchFieldsAndValuesRequestFromJSONTyped;
function TableauNlpRefinementuiSearchFieldsAndValuesRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'query': value.query,
        'lens_luid': value.lensLuid,
        'datasource_id': value.datasourceId,
        'lod_exp_in_play_json': value.lodExpInPlayJson,
        'selected_node_index': value.selectedNodeIndex,
        'phrase_shelf_type': value.phraseShelfType,
    };
}
exports.TableauNlpRefinementuiSearchFieldsAndValuesRequestToJSON = TableauNlpRefinementuiSearchFieldsAndValuesRequestToJSON;
